import { createStyles, makeStyles } from '@material-ui/core/styles';
export default makeStyles(theme => createStyles({
  passings: {
    display: 'grid',
    textAlign: 'left',
    gridTemplateColumns: '3fr 3fr 4fr 2fr 2fr',
    wordBreak: 'break-all'
  },
  column: {
    display: 'flex',
    flexDirection: 'column',
    marginRight: theme.spacing(3),
    marginBottom: theme.spacing(3),
    '&:last-child': {
      marginRight: 'initial'
    }
  }
}));